<!-- Modal Container -->
<mg-overlay-primary
  #overlayElement
  size="full"
  [isLoading]="isLoading$ | async"
  [overlayTitle]="form.formTitle || form.config.title"
  [skipLoadCheck]="true">
  <ng-container *ngTemplateOutlet="mainContent"></ng-container>
  <ng-template #overlayFooter>
    <ng-container *ngTemplateOutlet="footerContent"></ng-container>
  </ng-template>
</mg-overlay-primary>

<!-- Main Content Template -->
<ng-template #mainContent>
  <ng-container *ngTemplateOutlet="sideBarTemplate"></ng-container>
  <main
    fxFlex="grow"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="16px"
    fxLayoutGap.xs="0px"
    class="container-body">
    <!-- Quick Actions -->
    <ng-container
      *ngIf="showQuickActions$ | async"
      [ngTemplateOutlet]="quickActionsTemplate">
    </ng-container>
    <!-- Data Table -->
    <mg-ps-table
      fxFlex="grow"
      [form]="form">
    </mg-ps-table>
  </main>
</ng-template>

<!-- SideBar Template -->
<ng-template #sideBarTemplate>
  <aside
    class="container-sidebar"
    fxFlex="nogrow">
    <ng-container *ngIf="(form.pages.isMultiPage$ | async) === true">
      <mg-text
        variant="body-md-secondary"
        textAlign="left"
        spacing="3">
        {{ MSG.ACTION_LABEL }}
      </mg-text>
      <div class="tw-flex tw-gap-2 tw-mb-3">
        <mg-chip
          *ngFor="let page of form.pages.pages$ | async; index as i"
          [active]="(form.pages.activePath$ | async) === page.path"
          [showCheckmark]="false"
          [disabled]="
            (form.searchResults.isLoading$ | async) ||
            (form.pages.disabledPages$ | async | includes: page.path) ||
            form.isReadOnly
          "
          (pressed)="changeActivePage($any(page).path)">
          {{ page.text.title }}
        </mg-chip>
      </div>
    </ng-container>
    <mg-ps-search [form]="form"></mg-ps-search>
  </aside>
</ng-template>

<!-- Footer Content Template -->
<ng-template #footerContent>
  <footer
    class="overlay-footer"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="8px">
    <mg-btn
      variant="text"
      size="large"
      (pressed)="back()">
      Back
    </mg-btn>
    <div
      *ngIf="activePageOverrideConfig$ | async as activePageOverrideConfig"
      class="tw-flex tw-flex-row tw-gap-3">
      <mg-btn
        *ngIf="(form.pages.activePage$ | async)?.text?.secondaryActionLabel && form.isSecondaryActionEnabled$ | async"
        variant="outlined"
        size="large"
        [disabled]="
          form.isReadOnly || (form.pages.activePage$ | async).isReadOnly || (form.canSubmit$ | async) === false
        "
        (pressed)="form.submitSecondaryAction()">
        {{
          activePageOverrideConfig?.secondaryActionLabel ?? (form.pages.activePage$ | async)?.text?.secondaryActionLabel
        }}
      </mg-btn>

      <mg-btn
        variant="filled"
        size="large"
        [disabled]="
          form.isReadOnly || (form.pages.activePage$ | async).isReadOnly || (form.canSubmit$ | async) === false
        "
        (pressed)="form.submit()">
        {{ (form.pages.activePage$ | async)?.text?.submit }}
      </mg-btn>
    </div>
  </footer>
</ng-template>

<!-- Quick Actions Template -->
<ng-template #quickActionsTemplate>
  <div
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="20px"
    class="quick-action-container">
    <mg-btn
      *ngIf="canDownloadExport && (form.pages.activePageType$ | async) === 'list'"
      variant="text"
      size="small"
      iconSet="minga"
      icon="mg-export"
      (pressed)="form.exportData()">
      {{ MSG.BUTTON_LABEL_EXPORT }}
    </mg-btn>
  </div>
</ng-template>
